import { render } from "./AsGoodAsOurPeople.vue?vue&type=template&id=4c203ac0"
import script from "./AsGoodAsOurPeople.vue?vue&type=script&lang=ts"
export * from "./AsGoodAsOurPeople.vue?vue&type=script&lang=ts"

import "./AsGoodAsOurPeople.vue?vue&type=style&index=0&id=4c203ac0&lang=scss"
script.render = render

export default script